import { Schema, model } from 'mongoose';
import { paginate, toJSON } from '@/shared/utils/plugins';
import { ITag, ITagModel } from '../constructionStatus.interfaces';

const tagSchema = new Schema<ITag>(
  {
    name: { type: String, required: true, trim: true },
    createdBy: { type: Schema.Types.ObjectId, ref: 'User' },
    updatedBy: { type: Schema.Types.ObjectId, ref: 'User' },
  },
  { timestamps: true },
);

tagSchema.plugin(toJSON);
tagSchema.plugin(paginate);

const Tag = model<ITag, ITagModel>('Tag', tagSchema);
export default Tag;
